var map = {
	"./music-instructions.json": 4665,
	"./music-library-intro2024.json": 4666,
	"./music-library-launch2024.json": 4667,
	"./music-progression.json": 4668,
	"./startSourcesAdvanced.json": 4669,
	"./startSourcesSimple.json": 4670,
	"./startSourcesSimple2.json": 4671,
	"./startSourcesTracks.json": 4672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4443;